import { gql } from '@apollo/client';

export const getCiamUsers = gql`
  query Edges($parameters: CiamSearchParameters!, $after: String) {
    searchCiamUsers(parameters: $parameters, after: $after) {
      edges {
        node {
          name
          userId
          creationTime
          operationFlags {
            isAuthentication
            isOnboarding
            isTeseo
          }
          selfiePath
          updateTime
          operationCounter
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const searchUsersDetailOperations = gql`
  query SearchUsers($userId: String!, $parameters: CiamSearchParameters!) {
    searchUserDetailOperations(userId: $userId, parameters: $parameters) {
      edges {
        node {
          operationType
          operationId
          creationTime
          results {
            status
          }
          assets {
            url
            type
            hash
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const getUserDetail = gql`
  query GetUserDetails($userId: String!) {
    getUserDetails(userId: $userId) {
      personalInformation {
        name
        surname
        nationality
        documentNumber
        birthDate
        birthPlace
        address
        city
      }
      coordinates {
        longitude
        latitude
        type
      }
      credentials {
        credentialId
        credentialType
        data {
          address
          birthDate
          document
          email
          firstName
          lastName
          nationality
          phone
        }
        expirationDate
        issuanceDate
        type
        walletId
      }
      wallet {
        type
        walletId
        source
      }
    }
  }
`;

export const getUserLastOperation = gql`
  query SearchUserDetailOperations($userId: String!) {
    searchUserDetailOperations(userId: $userId, parameters: { limit: 1 }) {
      edges {
        node {
          operationId
        }
      }
    }
  }
`;
